export const SET_USER_PANEL = 'SET USER'
export const SET_POINTS_CONVERTION = 'SET POINTS CONVERTION'